<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Employee</h4>
                  <v-select
                    :options="employee"
                    label="displayName"
                    v-model="searchEmployee"
                    :class="{
                      'is-invalid ddl-is-invalid':
                        createReport_errors.employeeError,
                    }"
                  ></v-select>
                  <div
                    v-if="createReport_errors.employeeError"
                    class="invalid-feedback"
                  >
                    <span>{{ createReport_errors.employeeMessage }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Customer</h4>
                  <v-select
                    :options="customers"
                    label="customer"
                    v-model="searchCustomer"
                    @input="getJobs()"
                  ></v-select>
                </div>
              </div>
                            <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Job #</h4>
                  <v-select
                    :options="jobs"
                    item-text="label"
                    item-value="value"  
                    v-model="searchJobNum"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-3">
                <h4 class="card-title">Start Date</h4>
                <date-picker
                  v-model="searchStartDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
              <div class="col-lg-3">
                <h4 class="card-title">End Date</h4>
                <date-picker
                  v-model="searchEndDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
            </div>
            <!-- end row -->
            <div class="form-group row mt-4 d-flex justify-content-end align-items-end mr-2">
              <label class="mb-0 mr-2">Time Approval Status: </label>
              <div>
                <div class="d-flex" style="gap: 1rem;">
                  <b-form-radio
                    v-for="(type, typeIndex) in timeApprovalStatusFilters"
                    :key="typeIndex"
                    v-model="selectedTimeApprovalFilter"
                    :name="type.label"
                    :value="type.value"
                  >
                    {{ type.label }}
                  </b-form-radio>
                </div>
              </div>
            </div>
             <div class="row mt-3 mx-1 d-flex justify-content-end">
              <div class="mr-4">
                <switches
                  text-enabled="Products Shown"
                  text-disabled="Products Hidden"
                  v-model="showProducts"
                  type-bold="false"
                  color="primary"
                ></switches>
              </div>
              <div class="d-flex align-items-center">
                <div class="mr-4">
                  <div>
                    <ExportToExcel
                      :tableData="tableData"
                      :summaryTableData="summaryTableData"
                      :searchCustomer="searchCustomer"
                      :searchJobNum="searchJobNum? searchJobNum.value : null"
                      :searchStartDate="searchStartDate"
                      :searchEndDate="searchEndDate"
                      :exportType="'employee_hours'"
                    ></ExportToExcel>
                  </div>
                </div>
                <div class="mr-4">
                  <div>
                    <ReportsPDF
                      :tableData="tableData"
                      :summaryReport="summaryTableData"
                      :reportTotals="reportTotals"
                      :productTableData="productsTableData"
                      :productReportTotals="productReportTotals"
                      :searchCustomer="searchCustomer"
                      :searchJobNum="searchJobNum? searchJobNum.value : null"
                      :searchStartDate="searchStartDate"
                      :searchEndDate="searchEndDate"
                      :searchEmployee="searchEmployee"
                      :showProducts="showProducts"
                    ></ReportsPDF>
                  </div>
                </div>
                <div>
                  <div>
                    <b-button
                      id="btn_search"
                      variant="primary"
                      :disabled="loading"
                      v-on:click="generateReport()"
                      style="min-width: 86.98px"
                      >
                      <spring-spinner
                        v-if="loading"
                        class="label-spinner mx-auto"
                        :animation-duration="3000"
                        :size="20"
                        color="white"
                      />
                      <span v-else>Generate</span>
                    </b-button>
                  </div>
                </div>
              </div>
             </div>
             <div class="row mt-3 d-flex justify-content-end">
              <div>
                
              </div>
            </div>
            <!-- en row -->
          </div>
        </div>
        <!-- end card -->
        <!-- Totals -->
        <div class="row">
          <div
            v-for="total of reportTotals"
            :key="total.index"
            class="col-md-4"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.value"
            />
          </div>
        </div>
        <!-- /Totals -->
        <!-- Product Totals -->
        <div class="row" v-if="showProducts">
          <div
            v-for="total of productReportTotals"
            :key="total.index"
            class="col-md-4"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.value"
            />
          </div>
        </div>
        <!-- /Product Totals -->
        <!-- Table -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Times</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-compare="tableSort"
                :filter="filter"
                :filter-included-fields="filterOn"
                primary-key="id"
              >
                <template v-slot:cell(jobActions)="data">
                  <b-dropdown size="sm" variant="primary">
                    <template v-slot:button-content>
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item @click="updateJobCompleteStatus(data.item.JobDocID, data.item.JobCompletedStatus)">
                      <i class="bx mr-2 tableIcons" :class="!data.item.JobCompletedStatus ? 'bx-check' : 'bx-x'"></i>
                      {{!data.item.JobCompletedStatus ? 'Mark Job as Complete' : 'Mark Job as Incomplete'}}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToJob(data.item.Job)">
                      <i class="bx mr-2 tableIcons bx-log-in-circle"></i>
                      Go to Job
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:cell(approved)="data">
                  <div
                    :id="`hoursApproved-${data.item.id}`"
                    style="display: inline-block"
                  >
                    <b-form-checkbox v-model="data.item.approved" @change="(newValue) => approveTime(newValue, data.item.id)">
                    </b-form-checkbox>
                  </div>
                  <b-tooltip
                    :target="`hoursApproved-${data.item.id}`"
                    triggers="hover"
                    v-if="data.item.approved && data.item.approvedBy"
                  >
                    {{
                      `Approved by ${
                        data.item.approvedBy.name
                      } on ${data.item.approvedTime
                        .toString()
                        .substring(0, 15)} at ${data.item.approvedTime
                        .toString()
                        .substring(16, 21)}`
                    }}
                  </b-tooltip>
                </template>
                <template v-slot:cell(Job)="data">
                  <router-link
                    :to="{
                      path: '/production/jobs/jobDetails/' + getJobNumFromString(data.item.Job),
                    }"
                  >
                    <span :class="data.item.JobCompletedStatus ? 'text-success' : ''">{{data.item.Job}}</span>
                  </router-link>
                </template>
                <template v-slot:cell(type)="data">
                  <b-badge :variant="data.value === 'ot'
                  ? 'danger'
                  : data.value === 'tt'
                  ? 'info'
                  : 'success'">{{
                    data.value === 'ot'
                      ? 'Overtime'
                      : data.value === 'tt'
                      ? 'Travel'
                      : 'Regular'

                  }}</b-badge>
                </template>
                <template v-slot:cell(billable)="data">
                  <b-badge :variant="data.value ? 'success' : 'danger'">{{
                    data.value ? 'Yes' : 'No'
                   }}</b-badge>
                </template>
                                      
                <!-- <template slot="FOOT_b">
                        1
                      </template> -->
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
        <!-- summary table -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Hours/Product Summary</h4>
            <all-employees-summary-table
              :tableData="summaryTableData"
              :fields="fieldsSummary"
            >
            </all-employees-summary-table>
          </div>
        </div>
        <!-- /summary table -->

        <!-- Billable Products Table -->
        <BillableProductsTable
          :tableData="productsTableData"
          sourceReport="employeeHours"
          v-if="showProducts"
        >
        </BillableProductsTable>
        <!-- /Billable Products Table -->
        <!-- Chart -->
        <div class="row">
          <div
            v-bind:class="
              chart1Visible == false && chart2Visible == false
                ? 'col-12'
                : 'col-6'
            "
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Hours Worked by Day</h4>
                <!-- Column Charts -->
                <apexchart
                  class="apex-charts"
                  height="350"
                  type="area"
                  dir="ltr"
                  id="hoursByDays"
                  :series="hoursByDays.series"
                  :options="hoursByDays.chartOptions"
                ></apexchart>
              </div>
            </div>
          </div>
          <div
            v-if="showProducts"
            v-bind:class="
              chart1Visible == false && chart2Visible == false
                ? 'col-12'
                : 'col-6'
            "
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Products by Day</h4>
                <!-- Column Charts -->
                <apexchart
                  class="apex-charts"
                  height="350"
                  type="area"
                  dir="ltr"
                  id="hoursByDays"
                  :series="productsByDays.series"
                  :options="productsByDays.chartOptions"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="chart1Visible">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Employee's Hours by Job</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="hoursByJob.chartOptions"
                  :series="hoursByJob.series"
                  :labels="hoursByJob.labels"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="chart1Visible && showProducts">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Employee's Products by Job</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="productsByJob.chartOptions"
                  :series="productsByJob.series"
                  :labels="productsByJob.labels"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="chart2Visible">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Employee's Hours by Customer</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="hoursByCustomer.chartOptions"
                  :series="hoursByCustomer.series"
                  :labels="hoursByCustomer.labels"
                  class="reportsDonutChart"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="chart2Visible && showProducts">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Employee's Products by Customer</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="productsByCustomer.chartOptions"
                  :series="productsByCustomer.series"
                  :labels="productsByCustomer.labels"
                  class="reportsDonutChart"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Chart -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import DatePicker from 'vue2-datepicker';
import routes from '../../../routes.js';
import Stat from '@/components/widgets/stat';
import ReportsPDF from '../components/reports/reportsPDF.vue';
import BillableProductsTable from '../components/reports/billableProductsReportTable.vue';
import allEmployeesSummaryTable from '../components/reports/allEmployeesSummaryTable.vue';
import Switches from 'vue-switches';
import ExportToExcel from '../components/reports/ExportToExcel.vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Swal from 'sweetalert2';
import lodash from 'lodash';
import { SpringSpinner } from 'epic-spinners';
Vue.use(VueToast);

import firebase from 'firebase';
import {
  getCustomers,
  getJobsFromCustomer,
  getEmployees,
} from '../helper/dbHelpers.js';
import moment from 'moment';
import { tableSort } from '../helper/helpers.js';

export default {
  page: {
    title: 'Employee Hours Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Stat,
    ReportsPDF,
    BillableProductsTable,
    Switches,
    ExportToExcel,
    allEmployeesSummaryTable,
    SpringSpinner
  },
  data() {
    return {
      title: 'Employee Hours Report',
      name: 'hoursWorked',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'employee hours report',
          href: '/production/reports/hoursWorked',
          active: true,
        },
      ],
      routes: routes,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      perPageSummary: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'date',
      sortDesc: false,
      fields: [
        { key: 'jobActions', sortable: false },
        { key: 'approved', sortable: true },
        { key: 'Employee', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'Customer', sortable: true },
        { key: 'Job', sortable: true },
        { key: 'Description', sortable: true, class: 'jobDescription' },
        { key: 'Billable', sortable: true },
        { key: 'Type', sortable: true },
        { key: 'Hours', sortable: true },
        { key: 'Rate', sortable: true },
        { key: 'lineTotal', label: 'Line Total', sortable: true },
      ],
      customers: [],
      employee: [],
      jobs: [],
      searchCustomer: null,
      searchEmployee: null,
      searchJobNum: [],
      searchStartDate: null,
      searchEndDate: null,
      tableData: [],
      altTableData: [],
      productsTableData: [],
      chart1Visible: true,
      chart2Visible: true,
      createReport_errors: {
        employeeError: null,
        employeeMessage: null,
      },
      reportTotals: [
        {
          icon: 'bx bx-timer',
          title: 'Hours Worked',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Days Worked',
          value: '0',
        },
        {
          icon: 'bx bx-abacus',
          title: 'Avg. Hours/Day',
          value: '0',
        },
      ],
      productReportTotals: [
        {
          icon: 'bx bxs-purchase-tag-alt',
          title: 'Amount of Products Sold',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Amount of Days Products Sold',
          value: '0',
        },
        {
          icon: 'bx bx-stats',
          title: 'Avg. Products/Day',
          value: '0',
        },
      ],
      hoursByDays: {
        series: [
          {
            name: 'Hours Worked',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#556ee6'],
          },
          colors: ['#556ee6', '#556ee6', '#f46a6a'],
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'hours',
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 0,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' hours worked';
              },
            },
          },
        },
      },
      hoursByJob: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      hoursByCustomer: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      productsByDays: {
        series: [
          {
            name: 'Products Sold',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#556ee6'],
          },
          colors: ['#556ee6', '#556ee6', '#f46a6a'],
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'quantity',
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 0,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' products sold';
              },
            },
          },
        },
      },
      productsByJob: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      productsByCustomer: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      showProducts: false,
      fieldsSummary: [
        { key: 'name', sortable: true },
        {
          key: 'regularHours.value',
          // label: 'Regular Hours.value',
          label: 'Regular Hours',
          sortable: true,
        },
        {
          key: 'overtimeHours.value',
          label: 'Overtime Hours.value',
          // label: 'Overtime Hours',
          sortable: true,
        },
        {
          key: 'travelHours.value',
          label: 'Travel Hours.value',
          // label: 'Travel Hours',
          sortable: true,
        },
      ],
      summaryTableData: [],
      productsInTable: [],
      currentUser: this.$store.state.custom.currentUserData,
      timeApprovalStatusFilters: [
        { label: 'All', value: 'all' },
        { label: 'Only Approved', value: 'approved' },
        { label: 'Only Unapproved', value: 'unapproved' }
      ],
      selectedTimeApprovalFilter: 'all',
      loading: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    async altTableData(newItems) {
      // go through tabledata when it is changed and get job description for each alttabledata item
      // then add jobDescription to each alttabledata item and to corresponding item in the tableData array
      let array = [...newItems];
      let jobsMap = {};
      if (array.length > 0 && array.length !== undefined) {
        this.specificJob = [];

        for (let index = 0; index < array.length; index++) {
          let item = array[index];
          // limit db reads so it only gets unique Jobs by comparing to jobsMap
          if (jobsMap[item.Job] === undefined) {
            let query = firebase
              .firestore()
              .collection('jobs')
              .where('org', '==', sessionStorage.getItem('org'))
              .where('jobNum', '==', Number(item.Job));
            try {
              await query
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    // add job and job description to map
                    jobsMap[item.Job] = {
                      description: doc.data().description, 
                      jobCompletedStatus: doc.data().completed ?? false,
                      jobDocID: doc.id
                    };
                    // update tabledata
                    let timeItem = array[index];
                    timeItem.Job = timeItem.Job + ` - ${doc.data().description}`;
                    timeItem.JobCompletedStatus = doc.data().completed ?? false;
                    timeItem.JobDocID = doc.id;
                  });
                })
                .catch((err) => {
                  console.log(err);
                  Vue.$toast.open({
                    message: `Error getting specific job from database.`,
                    duration: 4000,
                    position: 'top-right',
                    dismissible: true,
                    type: 'error',
                  });
                });
            } catch (err) {
              console.log(err);
              Vue.$toast.open({
                message: `Error adding job descriptions to the time table`,
                duration: 4000,
                position: 'top-right',
                dismissible: true,
                type: 'error',
              });
            }
          } else {
            // job info for this table data item has already been pulled from db so find it in map and use it
            // update tabledata
            let jobData = jobsMap[item.Job];
            let timeItem = array[index];
            timeItem.Job = timeItem.Job + ` - ${jobData.description}`;
            timeItem.JobCompletedStatus = jobData.jobCompletedStatus;
            timeItem.JobDocID = jobData.jobDocID;
          }
        }
        // reset altTableData so it doesn't build up when user generates more than one report in one session
        this.altTableData = [];
      }
    },
    perPage(newVal, oldVal) {
      this.currentUser = this.$store.state.custom.currentUserData;
              let oldCurrentUserPerPage = null;

      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_employeeHoursTimes){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_employeeHoursTimes;
          }
          currentUserDataCopy.tablePageLengths['perPage_employeeHoursTimes'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_employeeHoursTimes: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (
          oldCurrentUserPerPage !== newVal
        ) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  methods: {
    approveTime: async function (value, id) {
      await this.$nextTick();
      try {
        let db = firebase.firestore();
        let page = db.collection('times').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.tableData.findIndex((data) => data.id === id);
        let newData = JSON.parse(JSON.stringify(this.tableData[index]));
        newData.approved = value;
        newData.approvedTime = value ? Date(approvedTime) : null;
        newData.approvedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;

        await page
          .update({
            approved: newData.approved,
            approvedTime: newData.approvedTime,
            approvedBy: newData.approvedBy,
          })
          .then(() => {
            this.tableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Time approved successfully'
                : 'Time unapproved successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing time approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the times approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },
    generateReport: async function () {
      // Validate search
      if (this.validateCreateReport()) {
        //construct the query string.
        try {
          this.loading = true
                    //in order the chart to auto render, we need to set the array, not just push data to it.
          let hoursWorkedData = [{ name: 'Hours Worked', data: [] }];
          let hoursWorkedDays = { categories: [] };
          let hoursWorkedJob = [];
          let hoursWorkedJobData = [];
          let hoursWorkedCustomer = [];
          let hoursWorkedCustomerData = [];

          let productsData = [{ name: 'Products Sold', data: [] }];
          let productsDays = { categories: [] };
          let productsJob = [];
          let productsJobData = [];
          let productsCustomer = [];
          let productsCustomerData = [];

          this.reportTotals[0].value = '0';
          this.reportTotals[1].value = '0';
          this.reportTotals[2].value = '0';

          this.productReportTotals[0].value = '0';
          this.productReportTotals[1].value = '0';
          this.productReportTotals[2].value = '0';

          this.tableData = [];
          this.summaryTableData = [];
          this.productsTableData = [];
          this.productsInTable = [];

          this.fieldsSummary = [
            { key: 'name', sortable: true },
            {
              key: 'regularHours.value',
              label: 'Regular Hours',
              sortable: true,
            },
            {
              key: 'overtimeHours.value',
              label: 'Overtime Hours',
              sortable: true,
            },
            { key: 'travelHours.value', label: 'Travel Hours', sortable: true },
          ];

          let query = firebase
            .firestore()
            .collection('times')
            .where('org', '==', sessionStorage.getItem('org'));

          if(this.selectedTimeApprovalFilter === 'approved'){
            query = query.where('approved', '==', true)
          }
          else if(this.selectedTimeApprovalFilter === 'unapproved'){
            query = query.where('approved', '==', false)
          }

          let productsQuery = firebase
            .firestore()
            .collection('billableProducts')
            .where('org', '==', sessionStorage.getItem('org'));

          if (this.searchEmployee != null && this.searchEmployee != '') {
            query = query.where('user', '==', this.searchEmployee.id);
            productsQuery = productsQuery.where(
              'user.uid',
              '==',
              this.searchEmployee.id
            );
          }
          if (this.searchCustomer != null && this.searchCustomer != '') {
            query = query.where(
              'customer',
              '==',
              this.searchCustomer.toLowerCase()
            );
            productsQuery = productsQuery.where(
              'customer',
              '==',
              this.searchCustomer.toLowerCase()
            );
          }
          if (this.searchJobNum != null && this.searchJobNum != '') {
                        query = query.where('jobNum', '==', Number(this.searchJobNum.value));
            productsQuery = productsQuery.where(
              'jobNum',
              '==',
              Number(this.searchJobNum.value)
            );
          }
          if (this.searchStartDate != null && this.searchStartDate != '') {
            query = query.where('date', '>=', this.searchStartDate);
            productsQuery = productsQuery.where(
              'date',
              '>=',
              this.searchStartDate
            );
          }
          if (this.searchEndDate != null && this.searchEndDate != '') {
            this.searchEndDate = new Date(
              moment(this.searchEndDate).endOf('day')
            );
            query = query.where('date', '<=', this.searchEndDate);
            productsQuery = productsQuery.where(
              'date',
              '<=',
              this.searchEndDate
            );
          }

          //logical processor for dispalying the chart
          if (this.searchCustomer != null && this.customer != '') {
            this.chart2Visible = false;
          } else {
            this.chart2Visible = true;
          }
          if (this.searchJobNum.value != null && this.searchJobNum.value != '') {
            this.chart1Visible = false;
          } else {
            this.chart1Visible = true;
          }

          //get the selected times.
          await query
            .orderBy('date', 'asc')
            .get()
            .then((querySnapshot) => {
              if (querySnapshot.empty) {
                console.log('No records returned.');
              }
              let currentDate;
              querySnapshot.forEach(async (doc) => {
                let newTime = {
                  id: doc.id,
                  approved: doc.data().approved,
                  approvedBy: doc.data().approvedBy,
                  approvedTime: doc.data().approvedTime,
                  Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  Employee: doc.data().employee,
                  Description: doc.data().description,
                  Billable: doc.data().billable ? false : true,
                  Hours: doc.data().hours,
                  Type: doc.data().overtime
                    ? 'ot'
                    : doc.data().travelTime
                    ? 'tt'
                    : 'reg',
                  Rate: doc.data().rate,
                  Job: `${doc.data().jobNum}`,
                  Customer: doc.data().customer,
                  lineTotal: (
                    Number(doc.data().hours) * Number(doc.data().rate)
                  ).toFixed(2),
                };

                this.tableData.push(newTime);
                this.altTableData.push(newTime);

                if (
                  currentDate !=
                  moment(doc.data().date.toDate()).format('MMM DD, YY')
                ) {
                  this.reportTotals[1].value = (
                    Number(this.reportTotals[1].value) + 1
                  ).toString();
                  hoursWorkedDays.categories.push(
                    moment(doc.data().date.toDate()).format('MMM DD, YY')
                  );
                  hoursWorkedData[0].data.push(Number(doc.data().hours));
                } else {
                  hoursWorkedData[0].data[hoursWorkedData[0].data.length - 1] =
                    hoursWorkedData[0].data[
                      hoursWorkedData[0].data.length - 1
                    ] + Number(doc.data().hours);
                }

                //start adding name to the labels for the pie chart.
                if (!hoursWorkedCustomer.includes(doc.data().customer)) {
                  if (doc.data().customer != undefined) {
                    hoursWorkedCustomer.push(doc.data().customer);
                  }
                }

                if (!hoursWorkedJob.includes(doc.data().jobNum)) {
                  hoursWorkedJob.push(doc.data().jobNum);
                }

                currentDate = moment(doc.data().date.toDate()).format(
                  'MMM DD, YY'
                );
                this.reportTotals[0].value = (
                  Number(this.reportTotals[0].value) + Number(doc.data().hours)
                )
                  .toFixed(2)
                  .toString();

                //add the hours for the customer and job.
                let customerIndex = hoursWorkedCustomer.indexOf(
                  doc.data().customer
                ); //customer
                hoursWorkedCustomerData[customerIndex] =
                  (hoursWorkedCustomerData[customerIndex] == undefined
                    ? 0
                    : hoursWorkedCustomerData[customerIndex]) +
                  Number(doc.data().hours); //hoursWorkedCustomerData[customerIndex] +
                let jobIndex = hoursWorkedJob.indexOf(doc.data().jobNum); //job
                hoursWorkedJobData[jobIndex] =
                  (hoursWorkedJobData[jobIndex] == undefined
                    ? 0
                    : hoursWorkedJobData[jobIndex]) + Number(doc.data().hours); //hoursWorkedJobData[jobIndex] +

                //parse the data for the summary table now.

                //Create the hours table data for the all employees summary table
                // value is the sum of all hours/products, total is the sum of the hours/products multiplied by the rate
                let regularHours = { value: 0, total: 0 };
                let overtimeHours = { value: 0, total: 0 };
                let travelHours = { value: 0, total: 0 };

                if (doc.data().overtime) {
                  overtimeHours = {
                    value: Number(doc.data().hours),
                    total: Number(doc.data().hours) * Number(doc.data().rate),
                  };
                } else if (doc.data().travelTime) {
                  travelHours = {
                    value: Number(doc.data().hours),
                    total: Number(doc.data().hours) * Number(doc.data().rate),
                  };
                } else {
                  regularHours = {
                    value: Number(doc.data().hours),
                    total: Number(doc.data().hours) * Number(doc.data().rate),
                  };
                }
                let index = this.summaryTableData.findIndex(
                  (x) => x.id === doc.data().user
                );
                //if the user already has an object, just add the total for the time to that object
                if (index !== -1) {
                  this.summaryTableData[index].regularHours.value +=
                    regularHours.value;
                  this.summaryTableData[index].overtimeHours.value +=
                    overtimeHours.value;
                  this.summaryTableData[index].travelHours.value +=
                    travelHours.value;
                  this.summaryTableData[index].regularHours.total +=
                    regularHours.total;
                  this.summaryTableData[index].overtimeHours.total +=
                    overtimeHours.total;
                  this.summaryTableData[index].travelHours.total +=
                    travelHours.total;
                } else {
                  //create an object for that user with the totals
                  this.summaryTableData.push({
                    name: doc.data().employee,
                    id: doc.data().user,
                    regularHours: regularHours,
                    overtimeHours: overtimeHours,
                    travelHours: travelHours,
                  });
                }
              });
              //set the chart data.
              this.hoursByDays.series = hoursWorkedData;
              this.hoursByCustomer.series = hoursWorkedCustomerData;
              this.hoursByJob.series = hoursWorkedJobData;
              //this ... notation takes all of the data that is in the object and we can just set one specific nessted object within it. Like so... (get it... ha!)
              this.hoursByDays.chartOptions = {
                ...this.hoursByDays.chartOptions,
                ...{
                  xaxis: hoursWorkedDays,
                },
              };
              this.hoursByCustomer.chartOptions = {
                ...this.hoursByCustomer.chartOptions,
                ...{
                  labels: hoursWorkedCustomer,
                },
              };
              this.hoursByJob.chartOptions = {
                ...this.hoursByJob.chartOptions,
                ...{
                  labels: hoursWorkedJob,
                },
              };
            })
            .catch((err) => {
              console.log(err);
              Vue.$toast.open({
                message: `Error generating report. Please contact support.`,
                duration: 8000000,
                position: 'top-right',
                dismissible: true,
                type: 'error',
              });
            });

          //get the selected products
          await productsQuery
            .orderBy('date', 'asc')
            .get()
            .then((querySnapshot) => {
              if (querySnapshot.empty) {
                console.log('No product records returned.');
              }
              let currentDate;
              querySnapshot.forEach((doc) => {
                //start adding the products to the summary data.
                let productIndex = this.summaryTableData.findIndex(
                  //check to see if the product already exists in the data.
                  (x) => x.id === doc.data().user.uid
                );

                if (productIndex !== -1) {
                  if (
                    this.summaryTableData[productIndex][doc.data().products] !==
                    undefined
                  ) {
                    //if the product is already present on the users object, just add to it
                    this.summaryTableData[productIndex][
                      doc.data().products
                    ].value += Number(doc.data().quantity);
                    this.summaryTableData[productIndex][
                      doc.data().products
                    ].total +=
                      Number(doc.data().quantity) * Number(doc.data().rate);
                  } else {
                    //add the product to every users object set to 0 and then set the appropriate user object to the quantity

                    this.summaryTableData.forEach((data, index) => {
                      this.summaryTableData[index][doc.data().products] = {
                        value: 0,
                        total: 0,
                      };
                    });
                    this.productsInTable.push(doc.data().products);
                    this.summaryTableData[productIndex][
                      doc.data().products
                    ].value = Number(doc.data().quantity);
                    this.summaryTableData[productIndex][
                      doc.data().products
                    ].total =
                      Number(doc.data().quantity) * Number(doc.data().rate);
                    this.fieldsSummary.push({
                      key: `${doc.data().products}.value`,
                      label: doc.data().products,
                      sortable: true,
                    });
                  }
                } else {
                  //if the user does not already have an object, create one for them
                  let newIndex = this.summaryTableData.push({
                    name: doc.data().user.name,
                    id: doc.data().user.uid,
                    regularHours: 0,
                    overtimeHours: 0,
                    travelHours: 0,
                  });
                  if (
                    this.summaryTableData[0][doc.data().products] === undefined
                  ) {
                    //if this product is not added to the rest of the objects yet, add it to all of them
                    this.summaryTableData.forEach((data, index) => {
                      this.summaryTableData[index][doc.data().products] = {
                        value: 0,
                        total: 0,
                      };
                    });
                    this.productsInTable.push(doc.data().products);
                  }
                  //add any missing fields to the newly added object
                  this.productsInTable.forEach((product) => {
                    this.summaryTableData[newIndex - 1][product] = {
                      value: 0,
                      total: 0,
                    };
                  });
                  //set the appropriate field to the quantity
                  this.summaryTableData[newIndex - 1][doc.data().products] = {
                    value: Number(doc.data().quantity),
                    total:
                      Number(doc.data().quantity) * Number(doc.data().rate),
                  };
                  this.fieldsSummary.push({
                    key: `${doc.data().products}.value`,
                    label: doc.data().products,
                    sortable: true,
                  });
                }

                let newProduct = {
                  Approved: doc.data().approved,
                  Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  Employee: doc.data().user.name,
                  Product: doc.data().products,
                  Quantity: doc.data().quantity,
                  Rate: doc.data().rate,
                  Job: doc.data().jobNum,
                  Customer: doc.data().customer,
                  lineTotal: (
                    Number(doc.data().quantity) * Number(doc.data().rate)
                  ).toFixed(2),
                };

                this.productsTableData.push(newProduct);

                if (
                  currentDate !=
                  moment(doc.data().date.toDate()).format('MMM DD, YY')
                ) {
                  this.productReportTotals[1].value = (
                    Number(this.productReportTotals[1].value) + 1
                  ).toString();
                  productsDays.categories.push(
                    moment(doc.data().date.toDate()).format('MMM DD, YY')
                  );
                  productsData[0].data.push(Number(doc.data().quantity));
                } else {
                  productsData[0].data[productsData[0].data.length - 1] =
                    productsData[0].data[productsData[0].data.length - 1] +
                    Number(doc.data().quantity);
                }

                //start adding name to the labels for the pie chart.
                if (!productsCustomer.includes(doc.data().customer)) {
                  if (doc.data().customer != undefined) {
                    productsCustomer.push(doc.data().customer);
                  }
                }

                if (!productsJob.includes(doc.data().jobNum)) {
                  productsJob.push(doc.data().jobNum);
                }

                currentDate = moment(doc.data().date.toDate()).format(
                  'MMM DD, YY'
                );
                this.productReportTotals[0].value = (
                  Number(this.productReportTotals[0].value) +
                  Number(doc.data().quantity)
                )
                  .toFixed(2)
                  .toString();

                //add the hours for the customer and job.
                let customerIndex = productsCustomer.indexOf(
                  doc.data().customer
                ); //customer
                productsCustomerData[customerIndex] =
                  (productsCustomerData[customerIndex] == undefined
                    ? 0
                    : productsCustomerData[customerIndex]) +
                  Number(doc.data().quantity);
                let jobIndex = productsJob.indexOf(doc.data().jobNum); //job
                productsJobData[jobIndex] =
                  (productsJobData[jobIndex] == undefined
                    ? 0
                    : productsJobData[jobIndex]) + Number(doc.data().quantity);
              });
              //set the chart data.
              this.productsByDays.series = productsData;
              this.productsByCustomer.series = productsCustomerData;
              this.productsByJob.series = productsJobData;
              //this ... notation takes all of the data that is in the object and we can just set one specific nessted object within it. Like so... (get it... ha!)
              this.productsByDays.chartOptions = {
                ...this.productsByDays.chartOptions,
                ...{
                  xaxis: productsDays,
                },
              };
              this.productsByCustomer.chartOptions = {
                ...this.productsByCustomer.chartOptions,
                ...{
                  labels: productsCustomer,
                },
              };
              this.productsByJob.chartOptions = {
                ...this.productsByJob.chartOptions,
                ...{
                  labels: productsJob,
                },
              };
            })
            .catch((err) => {
              console.log(err);
              Vue.$toast.open({
                message: `Error generating report. Please contact support.`,
                duration: 8000000,
                position: 'top-right',
                dismissible: true,
                type: 'error',
              });
            });

          //calculate the averages for the times and products.
          if (Number(this.reportTotals[1].value) != 0) {
            this.reportTotals[2].value = (
              Number(this.reportTotals[0].value) /
              Number(this.reportTotals[1].value)
            )
              .toFixed(2)
              .toString();
          } else {
            this.reportTotals[2].value = '--';
          }

          if (Number(this.productReportTotals[1].value) != 0) {
            this.productReportTotals[2].value = (
              Number(this.productReportTotals[0].value) /
              Number(this.productReportTotals[1].value)
            )
              .toFixed(2)
              .toString();
          } else {
            this.productReportTotals[2].value = '--';
          }
        } catch (err) {
          console.log(`Error getting job data: ${err}`);
        } finally{
          this.loading = false
        }
      }
    },
    getJobNumFromString(timeData){
      const jobString = timeData;
      let wordArray = jobString.split(" ");
      return wordArray[0];
    },
    updateJobCompleteStatus(jobDocID, jobCompleteStatus){
      //update the complete status of the job.
      try {
        firebase
          .firestore()
            .collection('jobs')
            .doc(jobDocID)
            .update({
              completed: !jobCompleteStatus,
            })
            .then(() => {
              // update local data
              let tableDataCopy = lodash.cloneDeep(this.tableData);
              // filter so we only have times associated with this specific jobDocID
              let jobTimes = tableDataCopy.filter((time) => time.JobDocID === jobDocID);
              jobTimes.forEach((time) => {
                time.JobCompletedStatus = !jobCompleteStatus;
              });
              // because jobTimes filtered times array references tableDataCopy, we can just update this.tableData with tableDataCopy
              this.tableData = tableDataCopy;
              Vue.$toast.open({
                message: 'Job status updated',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'Error updating the completed status of the job. (1)',
                'error'
              );
            });
      } catch (err) {
        Swal.fire(
          'Error!',
          'Error updating the completed status of the job. (2)',
          'error'
        );
      }
    },
    goToJob(jobNum){
      // pull the job number from the "job num - job description" string and push user to the job route
      this.$router.push(`/production/jobs/jobDetails/${this.getJobNumFromString(jobNum)}`);
    },
    getInitialCustomers() {
      getCustomers()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.customers.push(doc.data().displayName);
          });
        })
        .catch(() => {
          console.log(`Error getting customers...`);
        });
    },
    validateCreateReport: function () {
      let flag = true;
      //Employee not Selected
      if (this.searchEmployee == null) {
        this.createReport_errors.employeeError = true;
        this.createReport_errors.employeeMessage = 'Employee must be selected.';
        flag = false;
      } else {
        this.createReport_errors.employeeError = false;
        this.createReport_errors.employeeMessage = null;
      }

      return flag;
    },
    getInitialEmployees() {
      getEmployees()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let docData = doc.data();
            docData['id'] = doc.id;
            this.employee.push(docData);
          });
        })
        .catch(() => {
          console.log(`Error getting Employees...`);
        });
    },
    getJobs() {
      this.jobs = [];
      getJobsFromCustomer(this.searchCustomer)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const jobData = doc.data();
            this.jobs.push({ value: jobData.jobNum, label: `${jobData.jobNum} - ${jobData.description}` });
          });
        })
        .catch((err) => {
          console.log(`Error getting job numbers from customer.`);
          console.log(err);
        });
    },
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_employeeHoursTimes) {
          this.perPage =
            this.currentUser.tablePageLengths.perPage_employeeHoursTimes;
        }
      }
    },
    tableSort: tableSort,
  },
  created: function () {
    this.getInitialCustomers();
    this.getInitialEmployees();
    this.setTableSettings();
  },
};
</script>
